import { getHumanDiscount } from '../../../../functions/price';
import { Checkout } from '../../../../types';
import { Component, h, Prop } from '@stencil/core';
import { __ } from '@wordpress/i18n';
import { openWormhole } from 'stencil-wormhole';
import { formatTaxDisplay } from '../../../../functions/tax';

@Component({
  tag: 'sc-order-confirmation-totals',
  styleUrl: 'sc-order-confirmation-totals.css',
  shadow: true,
})
export class ScOrderConfirmationTotals {
  @Prop() order: Checkout;

  renderDiscountLine() {
    if (!this.order?.discount?.promotion?.code) {
      return null;
    }

    let humanDiscount = '';

    if (this.order?.discount?.coupon) {
      humanDiscount = getHumanDiscount(this.order?.discount?.coupon);
    }

    return (
      <sc-line-item style={{ marginTop: 'var(--sc-spacing-small)' }}>
        <span slot="description">
          {__('Discount', 'surecart')}
          <br />
          {this.order?.discount?.promotion?.code && (
            <sc-tag type="success" size="small">
              {this.order?.discount?.promotion?.code}
            </sc-tag>
          )}
        </span>
        {humanDiscount && (
          <span class="coupon-human-discount" slot="price-description">
            ({humanDiscount})
          </span>
        )}
        {this.order?.discounts_display_amount}
      </sc-line-item>
    );
  }

  render() {
    return (
      <div class={{ 'line-item-totals': true }}>
        <sc-line-item>
          <span slot="description">{__('Subtotal', 'surecart')}</span>
          <span slot="price">{this.order?.subtotal_display_amount}</span>
        </sc-line-item>

        {this.renderDiscountLine()}

        {!!this.order?.bump_amount && (
          <sc-line-item style={{ marginTop: 'var(--sc-spacing-small)' }}>
            <span slot="description">{__('Bundle Discount', 'surecart')}</span>
            <span slot="price">{this.order?.bump_display_amount}</span>
          </sc-line-item>
        )}

        {!!this.order?.shipping_amount && (
          <sc-line-item style={{ marginTop: 'var(--sc-spacing-small)' }}>
            <span slot="description">{__('Shipping', 'surecart')}</span>
            <span slot="price">{this.order?.shipping_display_amount}</span>
          </sc-line-item>
        )}

        {!!this.order?.tax_amount && (
          <sc-line-item style={{ marginTop: 'var(--sc-spacing-small)' }}>
            <span slot="description">
              {formatTaxDisplay(this.order?.tax_label)} {`(${this.order.tax_percent}%)`}
            </span>
            <span slot="price">{this.order?.tax_display_amount}</span>
          </sc-line-item>
        )}

        <sc-divider style={{ '--spacing': 'var(--sc-spacing-small)' }}></sc-divider>
        <sc-line-item-total checkout={this.order} size="large" show-currency>
          <span slot="description">{__('Total', 'surecart')}</span>
        </sc-line-item-total>
      </div>
    );
  }
}

openWormhole(ScOrderConfirmationTotals, ['order', 'busy', 'loading', 'empty'], false);
